import CardModal from '../CardModal';
import More from '../More';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import NextImage from '@/components/NextImage';
import SVGArrow from '@/components/UI/svg/corporatesocialresponsibility/SVGArrow';
import SVGMore from '@/components/UI/svg/corporatesocialresponsibility/SVGMore';

export default function D() {
    const { useEffect, useState, useLang, useRouter } = useGlobal();
    const { t } = useLang('corporatesocialresponsibility');
    const { locale } = useRouter();
    const [visible, setVisible] = useState(false);
    const [moreVisible, setMoreVisible] = useState(false);
    const [modalInfo, setModalInfo] = useState({});

    const clickCard = (card: any) => {
        setVisible(true);
        setModalInfo({
            title: card?.title,
            desc: card?.desc,
            imgs: card?.imgArr,
        });
    };

    const cards: any = [
        {
            title: t('secD_card6_text'),
            desc: t('secD_card6_desc'),
            webpImg: require('@publicLocal/corporate-social-responsibility/common/C1.jpg'),
            img: require('@publicLocal/corporate-social-responsibility/common/C1.jpg'),
            imgArr: [
                [require('@publicLocal/corporate-social-responsibility/common/C1.jpg'), require('@publicLocal/corporate-social-responsibility/common/C1.jpg')],
                [require('@publicLocal/corporate-social-responsibility/common/C2.jpg'), require('@publicLocal/corporate-social-responsibility/common/C2.jpg')],
                [require('@publicLocal/corporate-social-responsibility/common/C3.jpg'), require('@publicLocal/corporate-social-responsibility/common/C3.jpg')],
            ],
        },
        {
            title: t('secD_card2_text'),
            desc: t('secD_card2_desc'),
            webpImg: require('@publicLocal/corporate-social-responsibility/pc/4_2_1.jpg'),
            img: require('@publicLocal/corporate-social-responsibility/pc/4_2_1.jpg'),
            imgArr: [
                [require('@publicLocal/corporate-social-responsibility/pc/4_2_1.jpg'), require('@publicLocal/corporate-social-responsibility/pc/4_2_1.jpg')],
            ],
        },
        {
            title: t('secD_card3_text'),
            desc: t('secD_card3_desc'),
            webpImg: require('@publicLocal/corporate-social-responsibility/pc/4_3_1.webp'),
            img: require('@publicLocal/corporate-social-responsibility/pc/4_3_1.png'),
            imgArr: [
                [require('@publicLocal/corporate-social-responsibility/pc/4_3_1.webp'), require('@publicLocal/corporate-social-responsibility/pc/4_3_1.png')],
                [require('@publicLocal/corporate-social-responsibility/pc/4_3_2.webp'), require('@publicLocal/corporate-social-responsibility/pc/4_3_2.png')],
                [require('@publicLocal/corporate-social-responsibility/pc/4_3_3.webp'), require('@publicLocal/corporate-social-responsibility/pc/4_3_3.png')],
            ],
        },
        {
            title: t('secD_card1_text'),
            desc: t('secD_card1_desc'),
            webpImg: require('@publicLocal/corporate-social-responsibility/pc/4_1_1.webp'),
            img: require('@publicLocal/corporate-social-responsibility/pc/4_1_1.png'),
            imgArr: [
                [require('@publicLocal/corporate-social-responsibility/pc/4_1_1.webp'), require('@publicLocal/corporate-social-responsibility/pc/4_1_1.png')],
                [require('@publicLocal/corporate-social-responsibility/pc/4_1_2.webp'), require('@publicLocal/corporate-social-responsibility/pc/4_1_2.png')],
            ],
        },
    ];

    const moreArr: any = [
        {
            title: t('secD_card4_text'),
            desc: t('secD_card4_desc'),
            // webpImg: require('@publicLocal/corporate-social-responsibility/pc/4_4_1.webp'),
            // img: require('@publicLocal/corporate-social-responsibility/pc/4_4_1.png'),
            imgs: [
                [require('@publicLocal/corporate-social-responsibility/pc/4_4_1.webp'), require('@publicLocal/corporate-social-responsibility/pc/4_4_1.png')],
                [require('@publicLocal/corporate-social-responsibility/pc/4_4_2.webp'), require('@publicLocal/corporate-social-responsibility/pc/4_4_2.png')],
            ],
        },
        {
            imgs: [
                [require('@publicLocal/corporate-social-responsibility/pc/4_5_1.webp'), require('@publicLocal/corporate-social-responsibility/pc/4_5_1.png')],
            ],
            title: t('secD_card5_text'),
            desc: t(`secD_card5_desc`),
        },
    ];

    return (
        <div className={`csr-D ${css['csr-D']}`}>
            <div className="secD">
                <div className="content-box">
                    <div className="text-box">
                        <p className="title">{t('secD_title')}</p>
                        <p className="desc">{t('secD_desc')}</p>
                    </div>
                    <div className="card-box">
                        {cards?.map((card: any, k: number) => (
                            <div className={`card card${k + 1}`} onClick={() => clickCard(card)} key={k}>
                                <div className="img">
                                    <NextImage webpSrc={card?.webpImg || card.img} src={card.img} alt={card?.title} aria-label={card?.title} />
                                </div>
                                <div className="text-bar">
                                    <p className="text">{card?.title}</p>
                                    <SVGArrow />
                                </div>
                            </div>
                        ))}
                    </div>
                    <p className="more" onClick={() => setMoreVisible(true)}>
                        <span className="more-text">{t('secCommon_more')}</span>
                        <SVGMore />
                    </p>
                </div>
            </div>
            {visible && <CardModal title={modalInfo?.title} desc={modalInfo?.desc} imgs={modalInfo?.imgs} onClose={() => setVisible(false)} />}
            {moreVisible && <More arr={moreArr} onClose={() => setMoreVisible(false)} />}
        </div>
    );
}
